// @flow
import freeDammTostada from './freeDammTostada'

const type = 'specialPacks'

export default [
  {
    ...freeDammTostada,
    type
  }
]
